import { render, staticRenderFns } from "./figurearticleIndex.vue?vue&type=template&id=3ae6d0bd&scoped=true"
import script from "./figurearticleIndex.vue?vue&type=script&lang=js"
export * from "./figurearticleIndex.vue?vue&type=script&lang=js"
import style0 from "./figurearticleIndex.vue?vue&type=style&index=0&id=3ae6d0bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6d0bd",
  null
  
)

export default component.exports